"use client";

import React from "react";
import Action from "./Action";
import { WhatsApp as whatsAppIcon } from "@churchofjesuschrist/eden-icons";
import useValueOnMount from "./use-value-on-mount";
import buildURL from "./build-url";
import { jsx as _jsx } from "react/jsx-runtime";
const useWhatsAppShareUrl = ({
  shareUrl,
  shareText
} = {}) => {
  let args = {
    search: {
      text: `${useValueOnMount(() => shareText || document.title)} - ${useValueOnMount(() => shareUrl || window.location.href)}`
    }
  };
  return buildURL("https://wa.me/", args);
};

/**
 * A button that triggers a share to WhatsApp, to be used within an `ActionBar`.
 * @param {object} props - The component props
 * @param {string} [props.label] - Hidden text label for the button.
 * @param {string} [props.shareUrl] - The URL to share. Defaults to `window.location.href` once mounted.
 * @param {string} [props.shareText] - The additional text to share. Defaults to `document.title` once mounted.
 * @returns {React.ReactElement} The WhatsApp component
 */
const WhatsApp = ({
  shareUrl,
  shareText,
  label = "WhatsApp",
  ...props
}) => /*#__PURE__*/_jsx(Action, {
  ...props,
  href: useWhatsAppShareUrl({
    shareUrl,
    shareText
  }),
  Icon: whatsAppIcon,
  label: label
});
WhatsApp.displayName = "WhatsApp";
export default WhatsApp;